import { ReportSubmitPage } from '@/pages/employee/report/ReportSubmitPage';

interface ReportSubmitMobilePageProps {
  variant?: 'mobile' | 'mobile-view';
}

export function ReportSubmitMobilePage({ variant = 'mobile' }: ReportSubmitMobilePageProps) {
  return <ReportSubmitPage variant={variant} />;
}
